import React, {ReactNode} from "react";
import {Button, Flex, List} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil, faTrash} from "@fortawesome/free-solid-svg-icons";
import {useAppSelector} from "../../feature/tools";
import {editorRoles, WithUserPermission} from "./WithUserPermission";


export interface LayerListProps<T> {
    clickable?: boolean;
    itemStyle?: React.CSSProperties;
    data?: Array<T> | T;
    title: (item: T, index: number) => string | ReactNode | undefined | null;
    onItemClick: (item: T) => void;
    onDeleteClick: (item: T) => void;
    onEditClick: (item: T) => void;
    is?: (item: T) => boolean;

}

function LayersList<T>(
    {
        is,
        data,
        title,
        itemStyle,
        onItemClick,
        onDeleteClick,
        onEditClick,
        clickable
    }: LayerListProps<T>): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
    const dataSource = data ? Array.isArray(data) ? data : [data] : []

    return (
        <List dataSource={dataSource}
              locale={{emptyText: 'No items'}}
              renderItem={(item: T, index: number) =>
                  <Flex
                      style={{paddingTop: index == 0 ? 10 : 0, paddingBottom: index == dataSource?.length - 1 ? 10 : 0}}
                      align={'center'}
                      justify={'space-between'}>
                      <Button
                          style={
                              typeof title(item, index) === 'string' ? {
                                      ...itemStyle,
                                      flex: 1,
                                      overflow: 'hidden',
                                      textAlign: 'start'
                                  } :
                                  {
                                      ...itemStyle,
                                      flex: 1,
                                      textAlign: 'start',
                                      height: 'auto',
                                      overflow: 'hidden'
                                  }}
                          onClick={() => clickable ? onItemClick(item) : undefined}
                          type={is !== undefined && is(item) ? 'primary' : 'text'}
                      >
                         <span style={{
                             width: '100%',
                             textOverflow: 'ellipsis',
                             overflow: 'hidden',
                             display: 'block'
                         }}>{title(item, index)}</span>
                      </Button>
                      <WithUserPermission roles={editorRoles}>
                          {clickable ?
                              <>
                                  <Button
                                      type={'text'}
                                      onClick={() => onEditClick(item)}
                                      icon={<FontAwesomeIcon
                                          icon={faPencil} size={'xs'}/>}
                                  />
                                  <Button
                                      type={'text'}
                                      onClick={() => onDeleteClick(item)}
                                      icon={<FontAwesomeIcon
                                          icon={faTrash} size={'xs'}/>}
                                  />
                              </> : ''}
                      </WithUserPermission>
                  </Flex>
              }
        />
    )
}

declare namespace LayersList {
}
export default LayersList;